import { takeEvery, put, call, CallEffect, PutEffect } from "redux-saga/effects";

import {
  GET_AUTH_USER,
  LOGIN_USER,
  LOGIN_WITH_AUTH0,
  LOGOUT_USER,
  REFRESH_AUTH_USER,
  VALIDATE_VERIF_CODE,
  RESEND_VERIF_CODE,
} from "./actionTypes";

import {
  getAuthUserOk,
  getAuthUserErr,
  loginUserOk,
  loginUserErr,
  loginWithAuth0Ok,
  loginWithAuth0Err,
  logoutUserOk,
  logoutUserErr,
  refreshAuthUserOk,
  refreshAuthUserErr,
  validateVerifCodeOk,
  validateVerifCodeErr,
  resendVerifCodeOk,
  resendVerifCodeErr,
} from "./actions";

import {
  getAuthUser,
  loginUser,
  loginWithAuth0 as loginWithAuth0Api,
  logoutUser,
  validateVerifCode,
  resendVerifCode,
} from "~/helpers/backendHelper";
import { GetUserResponse } from "~/types/backend";
import { TAction } from "~/types/global";

function* onGetAuthUser(): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response: GetUserResponse = yield call(getAuthUser);
    yield put(getAuthUserOk(response));
  } catch (error) {
    yield put(getAuthUserErr(error as Error));
  }
}

function* onRefreshAuthUser(): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(getAuthUser);
    yield put(refreshAuthUserOk(response));
  } catch (error) {
    yield put(refreshAuthUserErr(error as Error));
  }
}

function* onLoginUser({ payload: { data } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(loginUser, data);
    yield put(loginUserOk(response));
  } catch (error) {
    yield put(loginUserErr(error as Error));
  }
}

function* onLogoutUser(): Generator<CallEffect | PutEffect, void, any> {
  try {
    yield call(logoutUser);
    yield put(logoutUserOk());
  } catch (error) {
    yield put(logoutUserErr(error as Error));
  }
}

function* onValidateVerifCode({ payload: { data } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(validateVerifCode, data);
    yield put(validateVerifCodeOk(response));
  } catch (error) {
    yield put(validateVerifCodeErr(error as Error));
  }
}

function* onResendVerifCode(): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(resendVerifCode);
    yield put(resendVerifCodeOk(response));
  } catch (error) {
    yield put(resendVerifCodeErr(error as Error));
  }
}

function* onLoginWithAuth0({ payload: { idToken } }: TAction): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(loginWithAuth0Api, idToken);
    yield put(loginWithAuth0Ok(response));
  } catch (error) {
    yield put(loginWithAuth0Err(error as Error));
  }
}

function* authSaga() {
  yield takeEvery(GET_AUTH_USER, onGetAuthUser);
  yield takeEvery(REFRESH_AUTH_USER, onRefreshAuthUser);
  yield takeEvery(LOGIN_USER, onLoginUser);
  yield takeEvery(LOGIN_WITH_AUTH0, onLoginWithAuth0);
  yield takeEvery(LOGOUT_USER, onLogoutUser);
  yield takeEvery(VALIDATE_VERIF_CODE, onValidateVerifCode);
  yield takeEvery(RESEND_VERIF_CODE, onResendVerifCode);
}

export default authSaga;
